import validate from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}